<template>
  <div class="info-page">
    <div class="info-card">
      <h6 class="info-title"><i class="fas fa-user mr-2"></i>ユーザー情報</h6>
      <table class="info-table">
        <tbody>
          <tr><th>名前</th><td>{{ data.name }}</td></tr>
          <tr><th>店舗</th><td>{{ data.shop }}</td></tr>
          <tr><th>勤務時間</th><td>{{ formattedStartTime }} 〜 {{ formattedStopTime }}</td></tr>
          <tr><th>休憩時間</th><td>{{ formattedBreakTime }}</td></tr>
          <tr v-if="data.hourly_wage"><th>時給</th><td>¥{{ Number(data.hourly_wage).toLocaleString() }}</td></tr>
          <tr v-if="Boolean(data.paid_leave)"><th>有給残日数</th><td>{{ data.remaining_paid_leave_days }}日</td></tr>
          <tr><th>メール</th><td>{{ user.email }}</td></tr>
          <tr><th>パスワード</th><td>●●●●●●●●</td></tr>
        </tbody>
      </table>
      <button class="logout-btn" @click="logout">
        <i class="fas fa-sign-out-alt mr-2"></i>ログアウト
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: [],
      user: [],
    }
  },
  mounted() {
    this.getUserInfo();
  },
  computed: {
    formattedStartTime() {
      return this.data.regular_working_hours_start ? this.data.regular_working_hours_start.slice(0, 5) : '00:00';
    },
    formattedStopTime() {
      return this.data.regular_working_hours_stop ? this.data.regular_working_hours_stop.slice(0, 5) : '00:00';
    },
    formattedBreakTime() {
      const hours = this.data.break_time ? this.data.break_time.toString().padStart(2, '0') : '00';
      return `${hours}:00`;
    }
  },
  methods: {
    getUserInfo () {
      this.$http.get(process.env.VUE_APP_API_PATH + '/staff/shop/0/me')
      .then(response => {
        if (response.data.success) {
          this.data = response.data.data.staff;
          this.user = response.data.data;
          this.data.shop = this.$store.getters.shop_name;
        }
      })
      .catch(error => {
        if (error.response) {
          this.$toast.error(error.response.data.message);
        }
      });
    },
    logout () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({ name: 'TimecardLogin' });
      })
    },
  },
}
</script>

<style scoped>
.info-page {
  display: flex;
  justify-content: center;
}

.info-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  padding: 24px;
  width: 100%;
  max-width: 440px;
}

.info-title {
  font-size: 15px;
  font-weight: 700;
  color: #049C4C;
  padding-bottom: 10px;
  margin-bottom: 4px;
  border-bottom: 2px solid #e2e8f0;
}

.info-table {
  width: 100%;
  margin-bottom: 24px;
}

.info-table th {
  font-size: 13px;
  font-weight: 600;
  color: #718096;
  padding: 10px 8px;
  width: 35%;
  border-bottom: 1px solid #edf2f7;
}

.info-table td {
  font-size: 15px;
  font-weight: 500;
  color: #1a202c;
  padding: 10px 8px;
  border-bottom: 1px solid #edf2f7;
  text-align: right;
}

.logout-btn {
  width: 100%;
  padding: 12px;
  background: #fff;
  color: #e53e3e;
  border: 2px solid #e53e3e;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.logout-btn:hover {
  background: #e53e3e;
  color: #fff;
}
</style>
